<router-outlet></router-outlet>
<ngx-spinner type="cube-transition"></ngx-spinner>
<app-toast aria-live="polite" aria-atomic="true"></app-toast>